<div class="brand" [class.brand--compact]="compact()">
  <img
    class="brand__wordmark"
    [class.brand__wordmark--compact]="compact()"
    src="assets/brand/SplitZero-wordmark-horizontal.svg"
    alt="SplitZero" />
  @if (!compact()) {
    @if (tagline(); as t) {
      <div class="brand__tagline">{{ t }}</div>
    }
  }
</div>
